import { z } from "zod";

export const AwIdSchema = z.object({
	aw_id: z.string()
});

export type AwId = z.infer<typeof AwIdSchema>;
